import React from 'react'
import { connect } from 'react-redux'

import Button from '@components/Button'

import { componentSelector } from '../../wordpress/selectors'

import '../styles/UGC.scss'

const UGCConfigurationSelector = componentSelector('UGC')

export const UserGeneratedContent = ({ UGC }) => {
    const getLink = () =>
        UGC.buttonAction === 'page'
            ? {
                  href: UGC.page,
              }
            : {
                  href: UGC.url,
                  external: true,
              }

    return (
        <div className="UGC container-fluid">
            <div className="inner-container">
                <Image className="img-container" image={UGC.image} background />
                <div className="info-container">
                    <h1>{UGC.title}</h1>
                    <div className="divider">
                        <hr />
                    </div>
                    <div className="text text-large">{UGC.content}</div>
                    <Button btnStyle="outline-invert" className="font-weight-bold" inline {...getLink()}>
                        {UGC.buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export const UGC = UGC => (UGC.enabled ? <UGC UGC={UGC} /> : null)

export default connect(UGCConfigurationSelector)(UGC)
